module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/vending-placeholder-path-14deaf3b1c70de305b86c6af2e0156c1.svg";